export default {
      id: "twitter-usage",
      viewBox: "0 0 274 223",
      url: __webpack_public_path__ + "icons-sprite.396b316.svg#twitter-usage",
      toString: function () {
        return this.url;
      }
    }